import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Zoom from "@mui/material/Zoom";

export default function AlertModal({ open, setOpen, message, onOk ,type ,closeable=false}) {
  const handleClose = () => {
    setOpen(false);
  };

  const handleOk = () => {
    if (onOk) onOk(); // Call the custom function passed via props
    handleClose();
  };
  const getAlertConfig = () => {
  switch (type) {
    case "success":
      return {
        icon: <CheckCircleIcon color="success" sx={{ fontSize: 80 }} />,
      };

    case "error":
      return {
        icon: <ErrorIcon color="error" sx={{ fontSize: 80 }} />,
      };

    case "warning":
      return {
        icon: <WarningAmberIcon color="warning" sx={{ fontSize: 80 }} />,
      };

    default:
      return {
        icon: <InfoIcon color="info" sx={{ fontSize: 80 }} />,
      };
  }
};
  const { icon } = getAlertConfig();


  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 3,
          padding: 2,
          textAlign: "center",
          boxShadow: 24,
        },
      }}
    >
      {/* Message Body */}
      <DialogContent>
        <Zoom in={open}>
        <Box
          sx={{
          display: "flex",
          justifyContent: "center",
          mb: 2,
          }}
          >
          {icon}
          </Box>
        </Zoom>
        <Typography
          id="alert-dialog-description"
          variant="body1"
          sx={{
            fontSize: "1.1rem",
            color: "text.primary",
            minHeight: 100,
            minWidth:100,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {message || "No message provided."}
        </Typography>
      </DialogContent>

      {/* OK Button */}
      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <Button
          onClick={handleOk}
          variant="contained"
          color="primary"
          size="large"
          sx={{
            minWidth: 100,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
          }}
        >
          OK
        </Button>
      </DialogActions>
      {closeable && (
      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        <Button
          onClick={handleClose}
          variant="outlined"
          color="primary"
          size="large"
          sx={{
            minWidth: 100,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
          }}
        >
          Close
        </Button>
      </DialogActions>)}
    </Dialog>
  );
}